type ErrorHandlerConfig = {
    errorCode: string;
    callback: () => void;
};

/**
 * Wraps a promise to handle specific error codes with callbacks
 * Always throws the original error after handling callbacks
 * @param promiseFunction - The async function that returns a promise
 * @param errorHandlers - Array of error code and callback configurations
 * @returns The wrapped promise
 */
export const withErrorHandler = async <T>(
    promiseFunction: () => Promise<T>,
    errorHandlers: ErrorHandlerConfig[]
): Promise<T> => {
    try {
        return await promiseFunction();
    } catch (error: any) {
        const errorCode = error.data?.errorCode;

        if (errorCode) {
            const handler = errorHandlers.find((h) => h.errorCode === errorCode);
            if (handler) {
                handler.callback();
            }
        }

        throw error;
    }
};
